import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { BancoldexService } from 'src/app/comun/services/bancoldex.service';
import { AlertService } from 'src/app/services/alert.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
@Component({
    selector: 'app-landing-aceptacion-creacion-credito',
    templateUrl: './landing-aceptacion-creacion-credito.component.html',
    styleUrls: ['./landing-aceptacion-creacion-credito.component.scss'],
    standalone: false
})
export class LandingAceptacionCreacionCreditoComponent implements OnInit {
  idSolicitud: string = "";
  mensajeBienvenida:string;
  constructor(
    private _user: UserService,
    private _bancoldexService:BancoldexService,
    private _alert: AlertService,
    private _sweetAlert:SweetAlertService) {
    }

  ngOnInit(): void {
    this.idSolicitud = this._user.getUser().idSolicitud;
    this.getMensajeConfirmacion();
  }

  getMensajeConfirmacion(){
    var json = {
      idParametro: 'PAR-090',
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response:any) => {
        this.mensajeBienvenida = response.data[0].valorParametro;
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error);
      }
    );
  }

}
